import { render, staticRenderFns } from "./SendPpwFile.vue?vue&type=template&id=24a295a0&scoped=true"
import script from "./SendPpwFile.vue?vue&type=script&lang=js"
export * from "./SendPpwFile.vue?vue&type=script&lang=js"
import style0 from "./SendPpwFile.vue?vue&type=style&index=0&id=24a295a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a295a0",
  null
  
)

export default component.exports